import React from "react";
import { TextField, Grid, Input, Select, MenuItem } from "@material-ui/core";
import { useFormContext, Controller } from "react-hook-form";

function FormInput({ label, name }) {
  const { control } = useFormContext();
  return (
    <Grid item xs={12} sm={6}>
      <Controller
        as={TextField}
        defaultValue={""}
        name={name}
        control={control}
        label={label}
        fullWidth
        required
      />
    </Grid>
  );
}

export default FormInput;
